module.exports = __webpack_public_path__ + "img/banner3.e43ae79e.jpg";